export const CalendarSvg = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.25 5.83366H1.75M9.33333 1.16699V3.50033M4.66667 1.16699V3.50033M4.55 12.8337H9.45C10.4301 12.8337 10.9201 12.8337 11.2945 12.6429C11.6238 12.4751 11.8915 12.2074 12.0593 11.8781C12.25 11.5038 12.25 11.0138 12.25 10.0337V5.13366C12.25 4.15357 12.25 3.66352 12.0593 3.28918C11.8915 2.95989 11.6238 2.69218 11.2945 2.5244C10.9201 2.33366 10.4301 2.33366 9.45 2.33366H4.55C3.56991 2.33366 3.07986 2.33366 2.70552 2.5244C2.37623 2.69218 2.10852 2.95989 1.94074 3.28918C1.75 3.66352 1.75 4.15357 1.75 5.13366V10.0337C1.75 11.0138 1.75 11.5038 1.94074 11.8781C2.10852 12.2074 2.37623 12.4751 2.70552 12.6429C3.07986 12.8337 3.56991 12.8337 4.55 12.8337Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalendarWithTickSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M6.75 12L8.25 13.5L11.625 10.125M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
      stroke="#1369E9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddBlockOutTimeInCalendarSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 3.75V14.25M3.75 9H14.25"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AwaitingAvailabilityActionSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7814_11136)">
      <path
        d="M8.00016 4.00001V8.00001L10.6668 9.33334M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7814_11136">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CalendarCenterPlusSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 6H2.25M12 1.5V3.75M6 1.5V3.75M9 13.5V9M6.75 11.25H11.25M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
      stroke="#1369E9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarPageMenuDropDownIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C13.8358 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.8358 9.75 14.25 9.75Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 9.75C4.16421 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.16421 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarPageGearIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.04634 14.5283L7.48468 15.5142C7.61498 15.8076 7.82763 16.057 8.09685 16.232C8.36606 16.4069 8.68026 16.5001 9.00134 16.5C9.32243 16.5001 9.63663 16.4069 9.90584 16.232C10.1751 16.057 10.3877 15.8076 10.518 15.5142L10.9563 14.5283C11.1124 14.1785 11.3748 13.8869 11.7063 13.695C12.0399 13.5026 12.4258 13.4206 12.8088 13.4608L13.8813 13.575C14.2006 13.6088 14.5228 13.5492 14.8089 13.4035C15.0949 13.2578 15.3326 13.0322 15.493 12.7542C15.6536 12.4763 15.7302 12.1577 15.7133 11.8372C15.6964 11.5166 15.5869 11.2079 15.398 10.9483L14.763 10.0758C14.5369 9.76285 14.4161 9.38611 14.418 9C14.4179 8.61494 14.5399 8.23976 14.7663 7.92833L15.4013 7.05583C15.5902 6.79632 15.6998 6.48755 15.7166 6.16701C15.7335 5.84646 15.657 5.52791 15.4963 5.25C15.3359 4.97193 15.0983 4.74637 14.8122 4.60067C14.5261 4.45497 14.2039 4.3954 13.8847 4.42917L12.8122 4.54333C12.4292 4.58356 12.0433 4.50159 11.7097 4.30917C11.3775 4.11619 11.115 3.82302 10.9597 3.47167L10.518 2.48583C10.3877 2.19238 10.1751 1.94304 9.90584 1.76805C9.63663 1.59306 9.32243 1.49995 9.00134 1.5C8.68026 1.49995 8.36606 1.59306 8.09685 1.76805C7.82763 1.94304 7.61498 2.19238 7.48468 2.48583L7.04634 3.47167C6.89104 3.82302 6.6285 4.11619 6.29634 4.30917C5.96275 4.50159 5.57684 4.58356 5.19384 4.54333L4.11801 4.42917C3.79876 4.3954 3.47656 4.45497 3.1905 4.60067C2.90443 4.74637 2.66677 4.97193 2.50634 5.25C2.34571 5.52791 2.26918 5.84646 2.28604 6.16701C2.30291 6.48755 2.41244 6.79632 2.60134 7.05583L3.23634 7.92833C3.4628 8.23976 3.58475 8.61494 3.58468 9C3.58475 9.38506 3.4628 9.76024 3.23634 10.0717L2.60134 10.9442C2.41244 11.2037 2.30291 11.5124 2.28604 11.833C2.26918 12.1535 2.34571 12.4721 2.50634 12.75C2.66693 13.0279 2.90461 13.2534 3.19064 13.399C3.47667 13.5447 3.79878 13.6044 4.11801 13.5708L5.19051 13.4567C5.57351 13.4164 5.95942 13.4984 6.29301 13.6908C6.62641 13.8833 6.89017 14.1765 7.04634 14.5283Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
